import React, {Component} from "react";
import AscModal from "../Elements/Modal/Modal";
import { Panel, Radio, Col, Glyphicon, Checkbox, Row, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as solidfaIcon from "@fortawesome/free-solid-svg-icons";
import "../Elements/FromGroup/form_select.css";
import CommonTable from "../Elements/Table/CommonTable";
import InlineForm from "../Elements/FromGroup/InlineForm";

export default class CallHistoryDetailModal extends Component {
    constructor(props) {
        super(props);

        this.table = React.createRef();
        this.state = {
            columns: this.getColumnsData(),
            data: [],
            pages: null,
            loading: false
        }
    }

    getColumnsData = () => {
        let {
            langText
        } = this.props;
        let columns = [];

        // 外線番号
        columns.push({
            Header: langText.Body.ExternalNumber,
            sortable: false,
            accessor: "display_number",
        });

        // 名称
        columns.push({
            Header: langText.Body.ExtensionName,
            sortable: false,
            accessor: "ct60_call_histories",
            Cell: data => {
                let returnValue = data.value && data.value.ct62_assgin_external_department_infos && 
                    data.value.ct62_assgin_external_department_infos.cm61_external_numbers && data.value.ct62_assgin_external_department_infos.cm61_external_numbers.memo 
                    ? data.value.ct62_assgin_external_department_infos.cm61_external_numbers.memo : "---";
                return returnValue;
            }
        });

        // 削除件数
        columns.push({
            Header: langText.Body.DeleteCount,
            sortable: false,
            accessor: "del_count",
            Cell: data => {
                return `${data.value.toLocaleString()}${langText.Body.Count}`;
            }
        });

        return columns;
    }

    getBoardData = async (state) => {
        const {
            page,
            pageSize,
        } = state;

        this.setState({ loading: true });

        try {
            const result = await this.props.ascAxios("post", `${this.props.reactContainerPath}/deleteHistoryResultBoard`, {
                page,
                pageSize,
                sm11_id: this.props.state.id,
                cm12_id: this.props.state.cm12_id,
                call_history_delete_flag: this.props.state.call_history_delete_flag,
                voice_log_delete_flag: this.props.state.voice_log_delete_flag
            });

            result.data.rows.forEach((row, idx) => {
                result.data.rows[idx].del_count = result.data.count[idx].count;
            });
            
            let count = result.data.count.length;

            this.setState({
                data: result.data.rows,
                page: state.page,
                pageSize: state.pageSize,
                pages: Math.ceil(count / state.pageSize),
                count: count,
                loading: false
            });
        } catch (err) {
            this.setState({
                data: [],
                pages: null,
                count: null,
                loading: false
            });

            this.props.showErrorObjectMesssage(err, "GetDataError_Server");
        }
    }

    getCallHistoryDetailInfoItem = () => {
        let {
            state,
            propState,
            langText,
            formatDisplayConditions,
            onTextChange_Limit,
            charaLimit,
            validationHandle
        } = this.props;
        let itemArr = [];
        let label = "";

        switch (state.modalType) {
            case "callHistoryDeleteExec":
                itemArr.push(
                    // メッセージ
                    <div className="message">
                        <p>{langText.Message.CallHistoryDeleteExecMessage[0]}</p>
                        <p>{langText.Message.CallHistoryDeleteExecMessage[1]}</p>
                        <p>{langText.Message.CallHistoryDeleteExecMessage[2]}</p>
                        <p>
                            {langText.Message.CallHistoryDeleteExecMessage[3]}
                            <span className="delete-count">{propState.searchCount !== "timeout" ? propState.searchCount.toLocaleString() + langText.Body.Count : langText.Message.TooManyResultsMessage}</span>
                        </p>
                        <p>{langText.Message.CallHistoryDeleteExecMessage[4]}</p>
                    </div>
                );

                // 検索条件
                label = formatDisplayConditions(propState.filtered);
                itemArr.push(
                    label.split("\n").map((line, index) => {
                        return <p key={"line" + index}>{line}</p>
                    })
                );

                if (state.delete_setting_expand) {
                    // 削除種類
                    itemArr.push(
                        <>
                            <Checkbox
                                checked={propState.call_history_delete_flag}
                                disabled
                                style={{display: 'block'}}
                            >
                                <span>{langText.Body.CallHistoryDelete}</span>
                                {
                                    propState.call_history_delete_flag &&
                                    <span className="waring-sentence">
                                        <FontAwesomeIcon
                                            className="margin-right-02"
                                            icon={solidfaIcon.faExclamationTriangle}
                                        />
                                        {langText.Message.Company_CallHistoryDelete}
                                    </span>
                                }
                            </Checkbox>
                            <Checkbox
                                checked={propState.voice_log_delete_flag}
                                disabled
                                style={{display: 'block'}}
                            >
                                <span>
                                    {langText.Body.VoiceLogDelete}
                                </span>
                                {
                                    propState.voice_log_delete_flag &&
                                    <span className="waring-sentence">
                                        <FontAwesomeIcon
                                            className="margin-right-02"
                                            icon={solidfaIcon.faExclamationTriangle}
                                        />
                                        {langText.Message.Company_VoiceLogDelete}
                                    </span>
                                }
                            </Checkbox>
                        </>
                    );
                }

                // 確認メッセージ
                itemArr.push(
                    <div className="message">
                        {
                            langText.Message.CallHistoryDeleteConfirmMessage.map((line, idx) => {
                                return (<p key={"line" + idx} className="padding-bottom-05">{line}</p>);
                            })
                        }
                    </div>
                );

                // メモ欄
                itemArr.push(
                    <InlineForm
                        key="memoField"
                        controlId="memoField"
                        label={langText.Body.MemoField}
                        type="text"
                        value={propState.memo}
                        onChange={e => onTextChange_Limit(e, "memo", charaLimit.CallHistory_memo)}
                        validationState={validationHandle("memo")}
                    />
                );

                // 確認欄
                itemArr.push(
                    <InlineForm
                        key="confirmField"
                        controlId="confirmField"
                        label={langText.Body.ConfirmField}
                        type="text"
                        value={propState.confirm}
                        onChange={e => onTextChange_Limit(e, "confirm", charaLimit.CallHistory_confirm)}
                        validationState={validationHandle("confirm")}
                        placeholder={langText.Message.CallHistoryConfirmPlaceholder}
                    />
                );
                break;
            case "callHistoryDeleteCancel":
                // メッセージ
                itemArr.push(
                    <div className="message">
                        <p>{langText.Message.CallHistoryDeleteCancelMessage[0]}</p>
                        <p>
                            {langText.Message.CallHistoryDeleteCancelMessage[1]}
                            <span className="delete-count">{state.del_count !== null ? state.del_count + langText.Body.Count : langText.Message.TooManyResultsMessage}</span>
                        </p>
                        <p>{langText.Message.CallHistoryDeleteCancelMessage[2]}</p>
                    </div>
                );

                // 検索条件
                label = state.condition_display.label;
                itemArr.push(
                    label.split("\n").map((line, index) => {
                        return <p key={"line" + index}>{line}</p>
                    })
                );

                // 削除種類
                let call_history_delete_flag = state.condition.call_history_delete_flag === "Y" ? true : false;
                let voice_log_delete_flag = state.condition.voice_log_delete_flag === "Y" ? true : false;
                if (state.delete_setting_expand) {
                    itemArr.push(
                        <>
                            <Checkbox
                                checked={call_history_delete_flag}
                                disabled
                                style={{display: 'block'}}
                            >
                                <span>{langText.Body.CallHistoryDelete}</span>
                                {
                                    call_history_delete_flag &&
                                    <span className="waring-sentence">
                                        <FontAwesomeIcon
                                            className="margin-right-02"
                                            icon={solidfaIcon.faExclamationTriangle}
                                        />
                                        {langText.Message.Company_CallHistoryDelete}
                                    </span>
                                }
                            </Checkbox>
                            <Checkbox
                                checked={voice_log_delete_flag}
                                disabled
                                style={{display: 'block'}}
                            >
                                <span>
                                    {langText.Body.VoiceLogDelete}
                                </span>
                                {
                                    voice_log_delete_flag &&
                                    <span className="waring-sentence">
                                        <FontAwesomeIcon
                                            className="margin-right-02"
                                            icon={solidfaIcon.faExclamationTriangle}
                                        />
                                        {langText.Message.Company_VoiceLogDelete}
                                    </span>
                                }
                            </Checkbox>
                        </>
                    );
                }

                // 確認メッセージ
                itemArr.push(
                    <div className="message">
                        {
                            langText.Message.CallHistoryDeleteCancelConfirmMessage.map((line, idx) => {
                                return (<p key={"line" + idx} className="padding-bottom-05">{line}</p>);
                            })
                        }
                    </div>
                );

                // メモ欄
                itemArr.push(
                    <InlineForm
                        key="memoField"
                        controlId="memoField"
                        label={langText.Body.MemoField}
                        type="text"
                        value={propState.memo}
                        onChange={e => onTextChange_Limit(e, "memo", charaLimit.CallHistory_memo)}
                        validationState={validationHandle("memo")}
                    />
                );

                // 確認欄
                itemArr.push(
                    <InlineForm
                        key="confirmField"
                        controlId="confirmField"
                        label={langText.Body.ConfirmField}
                        type="text"
                        value={propState.confirm}
                        onChange={e => onTextChange_Limit(e, "confirm", charaLimit.CallHistory_confirm)}
                        validationState={validationHandle("confirm")}
                        placeholder={langText.Message.CallHistoryDeleteCancelConfirmPlaceholder}
                    />
                );
                break;
        
            default:
                break;
        }

        return itemArr;
    }

    getModalInfo = () => {
        let {
            state,
            propState,
            langText,
            tableHeight
        } = this.props;
        let info = null;

        switch (state.modalType) {
            case "callHistoryDeleteExec":
                info = (
                    <>
                        <Panel bsStyle="info">
                            <Panel.Body>
                                {this.getCallHistoryDetailInfoItem()}
                            </Panel.Body>
                        </Panel>
                        <Col sm={12} md={12} className="text-right">
                            <span className="waring-sentence waring-font">
                                <FontAwesomeIcon
                                    className="margin-right-02"
                                    icon={solidfaIcon.faExclamationTriangle}
                                />
                                {langText.Message.CallHistoryDeleteExecAlertMessage}
                            </span>
                        </Col>
                    </>
                );
                break;
            case "callHistoryDeleteCancel":
                info = (
                    <Panel bsStyle="info">
                        <Panel.Body>
                            {this.getCallHistoryDetailInfoItem()}
                        </Panel.Body>
                    </Panel>
                );
                break;
            case "callHistoryDeleteDetail":
                const label = state.condition_display.label;

                info = (
                    <>
                        <Row className="flex-style">
                            <Col sm={12} md={4} lg={3}>
                                {`${langText.Body.DeleteCountPlus}: ${state.del_count}${langText.Body.Count}`}
                            </Col>
                            <Col sm={12} md={8} lg={6}>
                                <p>{langText.Message.CallHistoryDeleteMessage[2]}</p>
                                {label.split("\n").map((line, index) => {
                                    return <p key={"line" + index}>{line}</p>
                                })}
                            </Col>
                        </Row>
                        <Row>
                            {state.delete_setting_expand && (
                                <Col xs={12} md={12} className="margin-top-1">
                                    <Checkbox
                                        checked={state.call_history_delete_flag}
                                        disabled
                                        style={{display: 'block'}}
                                    >
                                        <span>{langText.Body.CallHistoryDelete}</span>
                                        {
                                            state.call_history_delete_flag &&
                                            <span className="waring-sentence">
                                                <FontAwesomeIcon
                                                    className="margin-right-02"
                                                    icon={solidfaIcon.faExclamationTriangle}
                                                />
                                                {langText.Message.Company_CallHistoryDelete}
                                            </span>
                                        }
                                    </Checkbox>
                                    <Checkbox
                                        checked={state.voice_log_delete_flag}
                                        disabled
                                        style={{display: 'block'}}
                                    >
                                        <span>
                                            {langText.Body.VoiceLogDelete}
                                        </span>
                                        {
                                            state.voice_log_delete_flag &&
                                            <span className="waring-sentence">
                                                <FontAwesomeIcon
                                                    className="margin-right-02"
                                                    icon={solidfaIcon.faExclamationTriangle}
                                                />
                                                {langText.Message.Company_VoiceLogDelete}
                                            </span>
                                        }
                                    </Checkbox>
                                </Col>
                            )}
                        </Row>
                        <Row>
                            <Col xs={12} md={12} className="margin-top-1">
                                <CommonTable
                                    className="call-history-modal"
                                    talbeRef={this.table}
                                    style={{height: tableHeight - 210}}
                                    manual="manual"
                                    columns={this.state.columns}
                                    data={this.state.data}
                                    pages={this.state.pages}
                                    pageSize={this.state.pageSize}
                                    loading={this.state.loading}
                                    onFetchData={(state, instance) => {
                                        this.getBoardData(state);
                                    }}
                                    previousText={langText.Table.PreviousText}
                                    nextText={langText.Table.NextText}
                                    loadingText={langText.Table.LoadingText}
                                    noDataText={langText.Table.NoDataText}
                                    rowsText={langText.Table.RowsText}/>
                            </Col>
                        </Row>
                    </>
                );
                break;

            default:
                break;
        }

        return info;
    }

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                customFunc={() => {
                    this.props.onClick();
                }}
                {...(this.props.state.modalType === "callHistoryDeleteDetail" ? {
                    customBtn1Func: () => {this.props.propSetState({ show: false })},
                    customBtn1Msg: this.props.langText.Body.Close
                } : {})}
            >
                {this.getModalInfo()}
            </AscModal>
        );
    }
}
